export enum BioReportRequestAction {
  DELETE = 'DELETE',
}
